const apiServerConstants = {
  host: process.env.REACT_APP_API_BASE_PATH 
}

export default apiServerConstants



// WEBPACK FOOTER //
// ./src/redux/sagas/apiServerConstants.js